export default "__VITE_ASSET__555d3ced__"